import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildIgloo: StructureBuilder = (world, spot) => {
    const { x, z, topAbs } = spot;
    const surfaceTop = world.get(x, topAbs + 1, z) === BLOCK.SnowBlock ? topAbs + 1 : topAbs;
    const brush = new StructureBrush(world, spot, surfaceTop);
    const size = 7;
    const centerX = 3;
    const centerZ = 3;
    const outerRadius = 3.5;
    const innerRadius = 2.5;
    const domeHeight = Math.ceil(outerRadius);

    for (let dy = 0; dy <= domeHeight; dy++) {
        for (let dx = 0; dx < size; dx++) {
            for (let dz = 0; dz < size; dz++) {
                const offsetX = dx - centerX;
                const offsetZ = dz - centerZ;
                const distance = offsetX * offsetX + offsetZ * offsetZ + dy * dy;
                if (distance > outerRadius * outerRadius || distance < innerRadius * innerRadius) {
                    continue;
                }
                if (dy <= 1 && dx === centerX && dz <= 1) continue;
                brush.block(dx, dy, dz, BLOCK.StructureSnow);
            }
        }
    }

    for (let dy = 0; dy <= 1; dy++) {
        brush.block(centerX - 1, dy, 0, BLOCK.StructureSnow);
        brush.block(centerX + 1, dy, 0, BLOCK.StructureSnow);
    }
    brush.lineX(centerX - 1, centerX + 1, 2, 0, BLOCK.StructureSnow);
    brush.block(centerX, domeHeight + 1, centerZ, BLOCK.IceSpike);
};
